import { useEffect, useState, useCallback } from 'react';
import { api } from '@/lib/api';

let memoryCache = {
  products: null,
  categories: null,
  ts: 0,
};
const TTL = 30 * 1000; // 30s

async function fetchAll() {
  const now = Date.now();
  if (memoryCache.products && now - memoryCache.ts < TTL) return memoryCache;
  const [p, c] = await Promise.all([api.get('/products'), api.get('/categories')]);
  memoryCache = { products: p.data, categories: c.data, ts: now };
  return memoryCache;
}

export const invalidateCatalog = () => { memoryCache = { products: null, categories: null, ts: 0 }; };

export function useCatalog() {
  const [products, setProducts] = useState(memoryCache.products || []);
  const [categories, setCategories] = useState(memoryCache.categories || []);
  const [loading, setLoading] = useState(!memoryCache.products);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchAll();
      setProducts(data.products || []);
      setCategories(data.categories || []);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  return { products, categories, loading, reload: load };
}

export async function getProductBySlug(slug) {
  // fast path from cache
  if (memoryCache.products) {
    const hit = memoryCache.products.find((p) => p.slug === slug);
    if (hit) return hit;
  }
  const { data } = await api.get(`/products/${slug}`);
  return data;
}
